import _ from 'lodash';
import template from './profile.html';


export default {
  name: 'profileComponent',
  template,
  controller: ProfileController,
  controllerAs: 'ProfCtrl'
};

/* @ngInject */
function ProfileController($scope, appConfig, ProfileService, UsersService) {
  const vm = this;

  let loaded = false;

  vm.user = {};
  vm.editing = false;

  vm.$onInit = getProfile;
  vm.$postLink = postLink;
  vm.getProfile = getProfile;

  function getProfile() {
    vm.user = ProfileService.getProfileData();
    loaded = false;
    vm.editing = false;
    ProfileService.getTwoFactor()
      .then((success) => {
        _.merge(vm.user, success.data);
        vm.authenticator = _.merge({
          enabled: Boolean(vm.user.secondFactorEnabled)
        }, success.data);
        loaded = true;
      });
  }

  function postLink() {
    $scope.$watch(() => vm.user.secondFactorEnabled, () => {
      if (loaded && vm.user.hasOwnProperty('secondFactorEnabled') && !vm.user.secondFactorEnabled) {
        UsersService.clearUsersTwoFactorSettings(vm.user.id)
          .then(() => {
            appConfig.user.secondFactorEnabled = false;
            vm.getProfile();
          })
          .catch((res) => {
            vm.authenticator.error = res.error;
          });
      }
    });
  }
}
